import { Trans, useLingui } from "@lingui/react/macro";
import { Button, Skeleton } from "@rakazo/ui-web";
import { LoaderCircle } from "lucide-react";
import { LoadingState } from "./ai/primitives";

/** Shared waiting surface; data fetching must opt in explicitly, not wait for Suspense.
 * Спільний стан очікування; запити даних вмикають його явно, незалежно від Suspense. */
export function ContentLoading({
  conversation = false,
  failed = false,
  onRetry,
}: {
  conversation?: boolean;
  failed?: boolean;
  onRetry?: () => void;
}) {
  const { t } = useLingui();
  return (
    <div
      data-testid="content-loading"
      data-conversation={conversation || undefined}
      className="flex min-h-0 flex-1 flex-col items-center justify-center gap-6 px-6 py-10"
    >
      {failed ? (
        <div className="flex flex-col items-center gap-3" role="alert">
          <p className="text-sm text-muted-foreground">
            <Trans>Could not load</Trans>
          </p>
          {onRetry ? (
            <Button variant="secondary" onClick={onRetry}>
              <Trans>Retry</Trans>
            </Button>
          ) : null}
        </div>
      ) : (
        <>
          <LoadingState
            label={t`Loading…`}
            indicator={
              <LoaderCircle
                aria-hidden="true"
                size={22}
                strokeWidth={1.6}
                className="animate-spin text-muted-foreground motion-reduce:animate-none"
              />
            }
          />
          {conversation ? (
            <div aria-hidden="true" className="flex w-full max-w-md flex-col gap-7">
              <div className="space-y-2">
                <Skeleton className="h-3 w-3/5" />
                <Skeleton className="h-3 w-4/5" />
                <Skeleton className="h-3 w-2/5" />
              </div>
              <Skeleton className="h-9 w-2/5 self-end rounded-2xl" />
              <div className="space-y-2">
                <Skeleton className="h-3 w-4/5" />
                <Skeleton className="h-3 w-3/5" />
              </div>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
}
